import { Divider, Grid, GridItem } from "@chakra-ui/react";
import { useIntl } from "react-intl";
import SelectInput from "../../inputs/SelectInput";
import FormInput from "../../inputs/FormInput";
import AutocompleteInput from "../../inputs/AutocompleteInput";
import ClientInfos from "./ClientInfos";
import { useState } from "react";

export default function IndividualForm({
  locale,
  purchaseTypes,
  selectedPurchaseType,
  handlePurchaseTypeChange,
  purchaseSubTypes,
  selectedPurchaseSubType,
  handlePurchaseSubTypeChange,
  purchaseCountry,
  setPurchaseCountry,
  purchaseShop,
  setPurchaseShop,
  buyOnPictureWebsite,
  livingCountry,
}) {
  const { sav_form } = useIntl().messages;
  const [isInvalid, setIsInvalid] = useState(false);

  const isOnlinePurchase =
    (selectedPurchaseType.code_liste === 14 && buyOnPictureWebsite === "no") ||
    (selectedPurchaseType.code_liste === 16 &&
      selectedPurchaseSubType.code_liste !== (55 || 56 || 57));

  const mapping = {
    US: 2,
    CH: 3,
    CA: 4,
    GB: 6,
  };

  const socCode = purchaseCountry
    ? purchaseCountry.CODE_SOC
    : mapping[livingCountry?.alpha2code] || 1;

  const availablePurchaseSubtypes =
    purchaseSubTypes &&
    (selectedPurchaseType.code_liste === 14
      ? purchaseSubTypes.filter((subtype) => subtype.code_liste !== 49)
      : purchaseSubTypes);

  return (
    <>
      {buyOnPictureWebsite === "yes" && (
        <>
          <input type="hidden" name="purchaseType" value="14" />
          <input type="hidden" name="purchaseSubType" value="49" />
          <input
            type="hidden"
            name="urlSite"
            value="picture-organic-clothing.com"
          />
        </>
      )}
      {buyOnPictureWebsite === "no" && (
        <Grid
          templateColumns={{
            sm: "repeat(2, 1fr)",
          }}
          gap={5}
          mt={5}
          width="100%"
        >
          {purchaseTypes && (
            <GridItem colSpan={2}>
              <SelectInput
                required
                name="purchaseType"
                id="purchaseType"
                value={selectedPurchaseType.code_liste}
                onChange={handlePurchaseTypeChange}
                options={purchaseTypes}
                optionKey={(item) => item.code_liste}
                optionValue={(item) => item.code_liste}
                optionLabel={(item) => item.commentaire}
                placeholder={sav_form.purchase_type.placeholder}
              >
                {sav_form.purchase_type.label}
              </SelectInput>
            </GridItem>
          )}

          {purchaseSubTypes &&
            availablePurchaseSubtypes &&
            (Array.isArray(availablePurchaseSubtypes) ? (
              <>
                <GridItem colSpan={2}>
                  <SelectInput
                    colSpan={2}
                    required
                    name="purchaseSubType"
                    id="purchaseSubType"
                    value={selectedPurchaseSubType.code_liste}
                    onChange={handlePurchaseSubTypeChange}
                    options={availablePurchaseSubtypes}
                    optionKey={(item) => item.code_liste}
                    optionValue={(item) => item.code_liste}
                    optionLabel={(item) => item.commentaire}
                    placeholder={sav_form.purchase_subtype.placeholder}
                  >
                    {sav_form.purchase_subtype.label}
                  </SelectInput>
                </GridItem>

                {isOnlinePurchase ? (
                  <GridItem colSpan={2}>
                    <input
                      type="hidden"
                      name="purchaseCountry"
                      value={livingCountry.name}
                    />
                    <FormInput
                      required
                      type="text"
                      name="urlSite"
                      placeholder={sav_form.store_link.placeholder}
                    >
                      {sav_form.store_link.label}
                    </FormInput>
                  </GridItem>
                ) : (
                  <GridItem colSpan={2}>
                    <AutocompleteInput
                      name="purchaseCountry"
                      label={sav_form.store.country.label}
                      placeholder={sav_form.store.country.placeholder}
                      apiIndex={`pays_${locale}`}
                      selectedItem={purchaseCountry}
                      setSelectedItem={setPurchaseCountry}
                      itemLabel={(item) => item.name}
                      fetchParams={{
                        attributesToSearchOn: ["name"],
                      }}
                      isRequired={true}
                    />
                  </GridItem>
                )}
              </>
            ) : (
              <input
                type="hidden"
                name="purchaseSubType"
                value={availablePurchaseSubtypes.code_liste}
              />
            ))}

          {purchaseCountry && selectedPurchaseType.code_liste === 63 && (
            <GridItem colSpan={2}>
              <AutocompleteInput
                name="purchaseShop"
                label={sav_form.company_name.label}
                placeholder={sav_form.company_name.placeholder}
                apiIndex={"boutiques"}
                selectedItem={purchaseShop}
                setSelectedItem={(item) => {
                  setPurchaseShop(item);
                  if (item) setIsInvalid(false);
                }}
                itemLabel={(item) => `${item.RAISON_SOCIALE} - ${item.VILLE}`}
                fetchParams={{
                  attributesToSearchOn: ["RAISON_SOCIALE", "VILLE"],
                  filter: `CODE_PAYS = ${purchaseCountry.alpha2code}`,
                  limit: 200,
                }}
                isInvalid={isInvalid}
                isRequired={true}
                errorText={sav_form.company_name_error}
                pattern="^(.+) - (.+)$"
                onBlur={() => {
                  if (!purchaseShop) {
                    setIsInvalid(true);
                  }
                }}
              />
            </GridItem>
          )}

          <input type="hidden" name="socCode" value={socCode} />

          {purchaseShop && (
            <>
              <input
                type="hidden"
                name="codeClient"
                value={purchaseShop.CODE_CLIENT}
              />
              <input
                type="hidden"
                name="currency"
                value={purchaseShop.CODE_MON}
              />
            </>
          )}
        </Grid>
      )}
      <Divider mt={6} />
      <ClientInfos />
      <Divider mt={6} />
    </>
  );
}
